import { render, staticRenderFns } from "./StaticCustomValueList.vue?vue&type=template&id=5d810570&scoped=true&"
import script from "./StaticCustomValueList.vue?vue&type=script&lang=js&"
export * from "./StaticCustomValueList.vue?vue&type=script&lang=js&"
import style0 from "./StaticCustomValueList.vue?vue&type=style&index=0&id=5d810570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d810570",
  null
  
)

export default component.exports